import * as Sentry from '@sentry/vue'
import router from './index'
import { companyGetters } from '@/store/modules/company/routines'
import { authGetters } from '@/store/modules/auth/routines'
import { updateDynamicFormListRoutine, dynamicFormListGetters } from '@/store/modules/dynamicFormList/routines'
import { swoopAPI } from '@/api/index'

const journeyState = {
  fundingApplication: {
    NOTFILLED: 'NotFilled',
    COMPLETED: 'Completed',
    AMOUNTSET: 'AmountSet'
  },
  integration: {
    SKIP: 'Skip',
    LINKED: 'Linked',
    NOTLINKED: 'NotLinked'
  },
  documentsState: {
    NOT_FILLED: 'NotFilled',
    SKIP: 'Skip',
    COMPLETED: 'Completed'
  },
  path: {
    DASHBOARD: 'dashboard'
  }
}

// Routes for which the Google Anayltics is disabled.
export const routeNamesWithoutGA = ['forgot-password', 'forgot-password-check-email', 'goals-form']

// Onboarding routes.
export const onboardingRoutes = ['product', 'goals', 'select-goal', 'goals-form', 'goals-form-sign-up', 'get-started', 'stage', 'details-page', 'sage-onboarding']

export const allowOnlyGuests = () => {
  return (to, from, next) => {
    const redirectTo = {
      name: to.query.deepLinkAction || journeyState.path.DASHBOARD
    }

    router.app.$authorize
      .isAuthorized(['guest'])
      .then(() => next())
      .catch(e => {
        // user is logged in, go to dashboard
        console.error(e.message)
        next(redirectTo)
      })
  }
}

export const allowOnlyWithCompany = (redirectTo = { name: journeyState.path.BUSINESS }) => {
  return (to, from, next) => {
    const companyId = router.app.$store.getters[companyGetters.COMPANY_ID]

    if (companyId) {
      next()
    } else {
      next(redirectTo)
    }
  }
}

export const allowOnlyWithCompletedJourney = () => {
  return async (to, from, next) => {
    const companyId = router.app.$store.getters[companyGetters.COMPANY_ID]

    if (companyId) {
      try {
        await router.app.$store.dispatch(updateDynamicFormListRoutine.TRIGGER)
        const dynamicFormList = router.app.$store.getters[dynamicFormListGetters.DYNAMIC_FORM_LIST]

        const onboardingIsInProgress = await swoopAPI.get(`api/v1/forms/in-progress-onboarding/${companyId}`)

        if (onboardingIsInProgress?.data?.isThereAnInProgressOnboarding) {
          const foundDynamicForm = dynamicFormList.find(form => form.formId === onboardingIsInProgress?.data?.formId)

          if (foundDynamicForm) {
            return next({
              name: 'get-started',
              query: { fundingReason: foundDynamicForm.name, version: foundDynamicForm.version }
            })
          }

          Sentry.captureMessage(`In-progress onboarding formId ${onboardingIsInProgress?.data?.formId} not found in dynamicFormList. User falling through to dashboard.`, 'warning')
        }
      } catch (error) {
        console.error('Error checking onboarding progress:', error)
        Sentry.captureException(error, { extra: { context: 'allowOnlyWithCompletedJourney guard' } })
      }
    }

    return next()
  }
}
